/* unplugin-vue-components disabled */import { render } from "./up-supported-by.vue?vue&type=template&id=4ebd9742"
const script = {}

import "./up-supported-by.vue?vue&type=style&index=0&id=4ebd9742&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/mainnet-unipass-wallet-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__